/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AuthCallbackRequest = {
  /**
   * The auth code for authentication from the speakeasy system
   */
  code?: string | undefined;
  /**
   * The identity provider error, when sign-in was not completed.
   */
  error?: string | undefined;
  /**
   * The opaque state string optionally provided during initialization.
   */
  state?: string | undefined;
};

export type AuthCallbackResponse = {
  headers: { [k: string]: Array<string> };
};

/** @internal */
export type AuthCallbackRequest$Outbound = {
  code?: string | undefined;
  error?: string | undefined;
  state?: string | undefined;
};

/** @internal */
export const AuthCallbackRequest$outboundSchema: z.ZodMiniType<
  AuthCallbackRequest$Outbound,
  AuthCallbackRequest
> = z.object({
  code: z.optional(z.string()),
  error: z.optional(z.string()),
  state: z.optional(z.string()),
});

export function authCallbackRequestToJSON(
  authCallbackRequest: AuthCallbackRequest,
): string {
  return JSON.stringify(
    AuthCallbackRequest$outboundSchema.parse(authCallbackRequest),
  );
}

/** @internal */
export const AuthCallbackResponse$inboundSchema: z.ZodMiniType<
  AuthCallbackResponse,
  unknown
> = z.pipe(
  z.object({
    Headers: z._default(z.record(z.string(), z.array(z.string())), {}),
  }),
  z.transform((v) => {
    return remap$(v, {
      "Headers": "headers",
    });
  }),
);

export function authCallbackResponseFromJSON(
  jsonString: string,
): SafeParseResult<AuthCallbackResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AuthCallbackResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AuthCallbackResponse' from JSON`,
  );
}
